import React from 'react';
import c from 'classnames';
// import { useTranslation } from 'react-i18next';

import formElementStyles from '../../layouts/FormElement/FormElement.scss';
import s from './InputLabelText.scss';

interface Props {
  className?: string;
  /** Will show "*Required" next to the label if true */
  isRequired?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * The text of an `<input />`'s label.
 *
 * NOTE: You still need need to wrap this in an `<InputLabel />` tag! This just provides the necessary styling to the text.
 */
const InputLabelText: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  isRequired,
  onClick,
}) => {
  // const { t } = useTranslation();
  return (
    <span className={c(s['root'], className)} onClick={onClick}>
      {children}{' '}
      {isRequired && (
        <span className={s['required-label']}>
          <span aria-hidden="true" title="Required">
            *
          </span>
          <span
            className={c(
              // we pull in the styles from the parent container
              // so it can use :focus-within to show 'required' when the field is focused
              formElementStyles['visually-hidden-required-text']
            )}
          >
            Required{/* t('common.required') */}
          </span>
        </span>
      )}
    </span>
  );
};
InputLabelText.displayName = 'InputLabelText';

export default InputLabelText;
